module.exports = __webpack_public_path__ + "static/media/ppimg.883e743d.svg";